import * as React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import { Spacer } from 'design-system/Spacer';
import LineChart from 'design-system/LineChart/LineChart';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import MaxPriceIndicator from './MaxPriceIndicator';
import MinPriceIndicator from './MinPriceIndicator';
import InitialPriceIndicator from './InitialPriceIndicator';
import LineBuyAndSellIndicators from './LineBuyAndSellIndicators';
import { ACTUAL_CHART_HEIGHT, LINE_CHART_WRAPPER_HEIGHT } from '../constants';
import { isWeb } from '../../../constants';
const PADDING_HORIZONTAL = rem(16);
const PADDING_VERTICAL = rem(34) - 10;
const StockLineChart = ({ dataObj, strokeColor, showBuyAndSell, selectedPeriod, selectedInfoObj, }) => {
    const colors = useColors();
    const { width } = useAppFrameDimensions(isWeb);
    const chartWidth = width - rem(32);
    const isActiveInPostTradingRef = React.useRef(undefined);
    const hasPostTradingPricesRef = React.useRef(undefined);
    React.useEffect(() => {
        if (typeof dataObj?.hasPostTradingPrices === 'boolean') {
            hasPostTradingPricesRef.current = dataObj?.hasPostTradingPrices;
        }
        if (typeof dataObj?.isActiveInPostTrading === 'boolean') {
            isActiveInPostTradingRef.current = dataObj?.isActiveInPostTrading;
        }
    }, [dataObj]);
    const points = React.useMemo(() => ({
        points1: dataObj?.dataPoints,
        points2: dataObj?.dataPoints2,
    }), [dataObj?.dataPoints, dataObj?.dataPoints2]);
    const activeMarkerColor = React.useMemo(() => {
        if (dataObj?.isActiveInPostTrading) {
            return colors.elements.secondaryLight;
        }
        if (dataObj?.isActiveInPostTrading === undefined && isActiveInPostTradingRef.current) {
            return colors.elements.secondaryLight;
        }
        return strokeColor;
    }, [colors.elements.secondaryLight, dataObj?.isActiveInPostTrading, strokeColor]);
    const line2StrokeColor = React.useMemo(() => {
        if (dataObj?.hasPostTradingPrices) {
            return colors.elements.secondaryTransparent;
        }
        if (dataObj?.hasPostTradingPrices === undefined && hasPostTradingPricesRef.current) {
            return colors.elements.secondaryTransparent;
        }
        return strokeColor;
    }, [colors.elements.secondaryTransparent, dataObj?.hasPostTradingPrices, strokeColor]);
    const maxPoint = dataObj?.maxPoint;
    const minPoint = dataObj?.minPoint;
    const initialPoint = dataObj?.initialPoint;
    return (<View>
      <Spacer h={12}/>
      <View>
        <LineChart combineLines hasActiveMarker width={chartWidth} canSelectEmptyPoints points={points.points1} strokeColor={strokeColor} height={ACTUAL_CHART_HEIGHT} points2={points.points2 || null} selectedInfoObj={selectedInfoObj} activePoint={dataObj?.finalPoint} line2StrokeColor={line2StrokeColor} activeMarkerColor={activeMarkerColor} paddingHorizontal={PADDING_HORIZONTAL} chartWrapperHeight={LINE_CHART_WRAPPER_HEIGHT}/>
        <InitialPriceIndicator width={chartWidth} initialPoint={initialPoint} height={ACTUAL_CHART_HEIGHT} paddingTop={PADDING_VERTICAL} selectedInfoObj={selectedInfoObj}/>
        <MaxPriceIndicator width={chartWidth} maxPoint={maxPoint} height={ACTUAL_CHART_HEIGHT} selectedInfoObj={selectedInfoObj}/>
        <MinPriceIndicator width={chartWidth} minPoint={minPoint} height={ACTUAL_CHART_HEIGHT} selectedInfoObj={selectedInfoObj}/>
        {showBuyAndSell && points.points1 && points.points2 ? (<LineBuyAndSellIndicators width={chartWidth} points={points.points1} points2={points.points2} height={ACTUAL_CHART_HEIGHT} selectedPeriod={selectedPeriod} selectedInfoObj={selectedInfoObj}/>) : null}
      </View>
    </View>);
};
export default React.memo(StockLineChart);
